module.exports = __webpack_public_path__ + "img/symbol-15-right.50c3e5b2.png";